module.exports = __webpack_public_path__ + "static/media/image_26.e0942908.png";